import 'chartjs-adapter-date-fns'; // Import adaptera daty

import {
    Chart as ChartJS,
    ArcElement,
    Tooltip,
    Legend,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    TimeScale,
  } from 'chart.js';
  
  // Rejestrujemy wszystkie niezbędne elementy
  ChartJS.register(
    ArcElement,
    Tooltip,
    Legend,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    TimeScale
  );